import { graphql } from "@graphql-generated/gql";

export const AlertsMenuQueryGraphql = graphql(`
    query Alerts($querySetting: QuerySettingInput!) {
        alertes(querySetting: $querySetting) {
            totalCount
            items {
                id
                dateDebut
                typeDalerte
                description
                dropPoint {
                    name
                }
            }
        }
    }
`);
